/**
 * How long to wait before the next status poll.
 *
 * Split out of PipelineDashboard so the schedule can be reasoned about (and
 * tested) without a component, a timer, or a fetch.
 */

/** Delay after any status change, and the starting delay. */
export const POLL_MIN_MS = 3000;
/** Heartbeat for a hidden tab or an empty queue, and the backoff ceiling. */
export const POLL_IDLE_MS = 30000;

/**
 * A fixed interval hammers the list endpoint at the same rate whether a job is
 * seconds or minutes from finishing. Processing takes 2-3 minutes, so the delay
 * grows while nothing changes and snaps back the moment something does.
 */
export function nextPollDelay(previousDelay: number, changed: boolean): number {
  if (changed) return POLL_MIN_MS;
  return Math.min(Math.round(previousDelay * 1.5), POLL_IDLE_MS);
}
